import axios from "axios";
import { REACT_APP_API_PAM_URL } from "../constants";
import { requestsFor } from "./headerService";
import { checkAPISuccess, manageServiceError } from "../utils/helpers";

const axiosInstance = axios.create({
    baseURL: `${REACT_APP_API_PAM_URL}`,
});

export const pamAxios = axiosInstance;

const requests = requestsFor(axiosInstance);

const path = {
    listConnections: "/connections/listConnections",
    instancesList: "/instances/list",
}


export async function getInstanceList({ payload, onSuccess, onFailure }) {
    try {
        const result = await requests.post(path.instancesList, payload);
        if (checkAPISuccess(result)) {
            onSuccess && onSuccess(result?.data);
        } else {
            onFailure && onFailure(result);
        }
    } catch (error) {
        manageServiceError(error, onFailure, "Instance List Failed");
    }
}

export async function getListConnections({ payload, onSuccess, onFailure }) {
    try {
        const result = await requests.post(path.listConnections, payload);
        if (checkAPISuccess(result)) {
            onSuccess && onSuccess(result?.data);
        } else {
            onFailure && onFailure(result);
        }
    } catch (error) {
        manageServiceError(error, onFailure, "List Connections Failed");
    }
}